import { Injectable, NgModule } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { DEBUG_INFO_ENABLED } from 'app/app.constants';

import { StateStorageService } from './core/auth/state-storage.service';
import { navbarRoute } from './layouts/navbar/navbar.route';
import { sidebarRoute } from './layouts/sidebar/sidebar.route';

const LAYOUT_ROUTES = [navbarRoute, sidebarRoute];

@Injectable({ providedIn: 'root' })
export class RedirectCompanyService {
  constructor(private readonly router: Router, private readonly stateStorageService: StateStorageService) { }

  canActivate(): boolean {
    const currentCompany = this.stateStorageService.getLoggedCompany();
    this.router.navigate(['/', currentCompany]);
    return false;
  }
}

@NgModule({
  imports: [
    RouterModule.forRoot(
      [
        {
          path: '',
          // redirectTo: 'pec',
          pathMatch: 'full',
          children: [],
          canActivate: [RedirectCompanyService],
        },
        {
          path: ':id',
          redirectTo: ':id/security/managedetails',
          pathMatch: 'full',
        },
        ...LAYOUT_ROUTES,
        {
          path: '**',
          children: [],
          canActivate: [RedirectCompanyService],
        },
      ],
      { enableTracing: DEBUG_INFO_ENABLED, scrollPositionRestoration: 'enabled' }
    ),
  ],
  exports: [RouterModule],
})
export class AccountPanelAppRoutingModule { }
